import { decodeUrl, encodeUrl } from './encodeUrl';

/** Query params usados por search/filtros nos passos do wizard de agendamento (admin). */
const SESSION_WIZARD_LIST_QUERY_KEYS = [
	'search',
	// Pacientes (passo 1)
	'banned',
	'is_complete',
	'club_id',
	'company_id',
	// Profissionais (passo 2)
	'authorized',
	'contract',
	'service_id',
	'service_modality',
] as const;

export function clearSessionWizardListQueryParams(
	searchParams: URLSearchParams,
): URLSearchParams {
	const next = new URLSearchParams(searchParams.toString());
	for (const key of SESSION_WIZARD_LIST_QUERY_KEYS) {
		next.delete(key);
	}
	return next;
}

/** Limpa search/filtros ao sair do passo de pacientes. */
export const clearSessionWizardPatientQueryParams =
	clearSessionWizardListQueryParams;

/** Limpa search/filtros ao sair do passo de profissionais. */
export const clearSessionWizardProfessionalQueryParams =
	clearSessionWizardListQueryParams;

type WizardEncodedState = Record<string, string | number | boolean>;

/** Clique em "Próxima etapa": zera filtros/search na URL e avança o estado do wizard em `d`. */
export function advanceSessionWizardStep(
	searchParams: URLSearchParams,
	wizardPatch: WizardEncodedState,
): URLSearchParams {
	const next = clearSessionWizardListQueryParams(searchParams);
	const encoded = searchParams.get('d');
	const decoded = encoded ? (decodeUrl(encoded) as WizardEncodedState) : {};

	next.set(
		'd',
		encodeUrl({
			...decoded,
			...wizardPatch,
			lr: Date.now(),
		}),
	);

	return next;
}

export function getSessionWizardListPanelKey(
	searchParams: URLSearchParams,
	fallback = '0',
): string {
	const encoded = searchParams.get('d');
	if (!encoded) return fallback;

	const decoded = decodeUrl<{ lr?: number | string }>(encoded);
	return decoded.lr != null ? String(decoded.lr) : fallback;
}
